import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101234 86078"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:1467.15}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528324039488">
        <path
          d="M94793 4488H6442c-383 0-694-310-694-692 0-383 310-693 693-693h88352c383 0 692 310 692 693 0 382-309 692-692 692z"
          className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}
        />
        <path
          d="M3797 2119c-926 0-1677 752-1677 1677 0 924 751 1676 1676 1676s1676-752 1676-1676c0-925-751-1677-1675-1677zm0 4738c-1689 0-3063-1373-3063-3061 0-1689 1374-3062 3062-3062 1690-2 3063 1373 3063 3062 0 1688-1373 3061-3062 3061zM97438 2119c-926 0-1677 752-1677 1677 0 924 751 1676 1677 1676 924 0 1676-752 1676-1676 1-925-752-1677-1676-1677zm0 4738c-1689 0-3063-1373-3063-3061 0-1689 1374-3062 3063-3062 1689-2 3062 1373 3062 3062 0 1688-1373 3061-3062 3061zM40470 58827c-138 0-279-43-402-131-8650-6192-15678-12928-20885-20019-4178-5689-7202-11620-8986-17628C7145 10775 8759 3917 8829 3631c91-372 465-600 838-509s600 467 508 838c-25 108-1586 6881 1379 16790 2751 9192 10070 23040 29321 36820 311 223 383 656 160 967-135 189-348 290-565 290zM60764 58827c-217 0-429-101-565-290-223-311-151-744 160-967 19252-13780 26571-27628 29321-36820 2975-9940 1395-16723 1379-16790-91-373 136-747 508-838s746 137 837 509c71 286 1685 7144-1367 17418-1784 6008-4806 11939-8985 17628-5207 7091-12235 13827-20885 20019-123 88-264 131-403 131z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}

        />
        <path
          d="M26859 33721c-254 0-499-141-619-383-4856-9701-6384-17229-6809-21834-467-5049 232-7772 261-7885 97-371 477-591 847-492 369 96 591 475 494 845-10 36-672 2674-213 7501 424 4471 1924 11787 6658 21245 171 341 33 758-309 930-100 50-207 73-310 73zM39377 40819c-273 0-531-161-641-430-7346-17931-8755-36360-8769-36544-28-381 259-713 641-741 381-27 713 260 741 642 13 182 1408 18398 8669 36118 145 354-25 759-378 904-87 35-176 51-263 51zM68931 43677c-129 0-261-35-378-111-320-209-410-639-203-958 8193-12602 11058-22440 12019-28476 1040-6526 137-10125 126-10160-95-370 127-749 496-845 370-97 749 123 845 492 40 153 982 3840-80 10615-969 6189-3881 16265-12244 29129-132 204-353 316-581 314zM65429 31658c-67 0-138-10-207-32-365-113-569-502-456-867 4451-14334 5405-26889 5414-27013 28-382 358-669 741-642 381 28 669 360 641 741-9 127-971 12832-5471 27325-93 298-367 488-662 488zM39488 79074c-61 0-123-3-186-12-3533-489-5802-1658-6744-3477-2627-5078 6553-13366 6947-13717 334-299 947-347 1367-110 420 240 487 675 154 975-89 79-8894 8025-6643 12372 700 1353 2431 2202 5289 2597 528 72 873 436 770 811-89 332-497 562-954 561z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}

        />
        <path
          d="M38216 58826c-767 0-1390 625-1390 1392 0 766 623 1389 1390 1389h25096c767 0 1391-623 1391-1389 0-767-624-1391-1391-1391l-25096-1zm25096 4168H38216c-1531 0-2775-1246-2775-2776 0-1532 1244-2777 2775-2777h25096c1530 0 2776 1245 2776 2777 0 1530-1246 2776-2776 2776z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}

        />
        <path
          d="m50789 85344-222-1c-5352-390-8951-2249-10696-5525-3666-6886 2270-17416 2524-17862 189-331 613-447 945-256 333 189 447 613 258 945-59 102-5811 10314-2503 16524 1504 2821 4717 4434 9548 4790h96c4831-356 8043-1969 9546-4790 3310-6210-2442-16422-2503-16524-187-332-73-756 259-945 331-191 755-75 944 256 256 445 6190 10976 2525 17862-1744 3276-5343 5136-10697 5525l-24 1z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}

        />
        <path
          d="M62015 79074c-488 0-924-229-1020-561-110-375 259-739 822-811 3059-395 4909-1244 5659-2597 2408-4347-7010-12293-7106-12372-356-300-283-735 165-975 450-237 1105-189 1463 110 419 351 10240 8639 7429 13717-1008 1819-3434 2988-7212 3477-68 9-134 13-200 12z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1467.15,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
